import { ErrorMessage } from "@hookform/error-message";

type PropsType = {
  label?: string;
  name?: string;
  register?: any;
  required?: boolean;
  watch?: any;
  errors?: any;
  width?: any;
  rows?: any;
  onChange?: any;
  disabled?: boolean;
};

const Textarea: React.FC<PropsType> = ({
  name,
  label,
  register,
  required,
  watch,
  errors,
  width,
  rows,
  onChange,
  disabled = false,
}) => {
  const validationStyle = () => {
    if (errors && errors[name]) {
      return "ring-red-600 ring-2";
    } else {
      return "";
    }
  };
  return (
    <div className={`flex flex-col h-full ${width ? width : ""}`}>
      <div className="relative flex items-start w-full mt-3 mb-3 group">
        <label
          className={`absolute capitalize group-hover:-translate-y-0 px-3 text-sm font-normal transition-all duration-300 text-old-silver ${
            watch()[name] ? "-translate-y-0" : "translate-y-5"
          }`}
        >
          {label ? label : name}
        </label>
        <textarea
          aria-label={label}
          label={label ? label : name}
          {...register(name, { onChange, required })}
          rows={rows ? rows : 5}
          disabled={disabled}
          className={`${
            disabled ? "cursor-not-allowed opacity-30" : ""
          } w-full h-full px-3 pt-4 text-base font-bold outline-none appearance-none bg-[#F7F7F7] rounded-md text-[#585757] ${validationStyle()}`}
        />
      </div>
      {errors && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <small className="px-3 -mt-2 text-red-600">{message}</small>
          )}
        />
      )}
    </div>
  );
};

export default Textarea;
